import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
// import { changeCouponStatus } from "services/discountManagement";
import { toastMessage } from "utils/toastMessage";
import { changeCategoryStatus } from "services/category";

const ChangeCategoryStatus = ({
  selectedCategoryDetail,
  onClose,
  catDataFetchApiCall,
  statusModal,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const status = selectedCategoryDetail.status === "ACTIVE" ? "Hide" : "Unhide"
  // console.log("it is selected Token status:--------", selectedCategoryDetail);

  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        id: selectedCategoryDetail?._id || "",
        status:
          selectedCategoryDetail.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };

      const {
        data: { code, status, message },
      } = await changeCategoryStatus(reqData);
      if (status || code === 200) {
        catDataFetchApiCall();
        onClose();
        toastMessage(message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={statusModal}
        handleClose={onClose}
        content={`Are You Sure , You Want To ${status} This Category?`}
        title="Change Status Category"
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default ChangeCategoryStatus;
